"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.batchSaveBrandConfig = batchSaveBrandConfig;
exports.deleteBrandConfig = deleteBrandConfig;
exports.getBrandConfigList = getBrandConfigList;
exports.getFlowerConfig = getFlowerConfig;
exports.getJoyShareConfig = getJoyShareConfig;
exports.saveBrandConfig = saveBrandConfig;
exports.saveFlowerConfig = saveFlowerConfig;
exports.saveJoyShareConfig = saveJoyShareConfig;
var _request = _interopRequireDefault(require("@/utils/request"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * 获取品牌配置列表
 */
function getBrandConfigList() {
  return (0, _request.default)({
    url: '/admin/meal/config/brand/list',
    method: 'get'
  });
}

/**
 * 批量保存或更新品牌配置
 * @param {Object} data
 */
function batchSaveBrandConfig(data) {
  return (0, _request.default)({
    url: '/admin/meal/config/brand/batch-save',
    method: 'post',
    data: data
  });
}

/**
 * 保存或更新品牌配置
 * @param {Object} data
 */
function saveBrandConfig(data) {
  return (0, _request.default)({
    url: '/admin/meal/config/brand/save',
    method: 'post',
    data: data
  });
}

/**
 * 删除品牌配置
 * @param {number} id
 */
function deleteBrandConfig(id) {
  return (0, _request.default)({
    url: "/admin/meal/config/brand/delete/".concat(id),
    method: 'post'
  });
}

/**
 * 获取花喜供应商配置
 */
function getFlowerConfig() {
  return (0, _request.default)({
    url: '/admin/meal/config/flower/info',
    method: 'get'
  });
}

/**
 * 保存或更新花喜供应商配置
 * @param {Object} data
 */
function saveFlowerConfig(data) {
  return (0, _request.default)({
    url: '/admin/meal/config/flower/save',
    method: 'post',
    data: data
  });
}

/**
 * 获取乐享汇供应商配置
 */
function getJoyShareConfig() {
  return (0, _request.default)({
    url: '/admin/meal/config/joyshare/info',
    method: 'get'
  });
}

/**
 * 保存或更新乐享汇供应商配置
 * @param {Object} data
 */
function saveJoyShareConfig(data) {
  return (0, _request.default)({
    url: '/admin/meal/config/joyshare/save',
    method: 'post',
    data: data
  });
}